import { useCallback, useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { DISPLAY_MODES, ROUTES } from '../constants';

export const useDisplayMode = () => {
  const location = useLocation();
  const history = useHistory();
  const [displayMode, setDisplayMode] = useState(DISPLAY_MODES.FUNNEL);

  const updateDisplayMode = useCallback((newMode) => {
    if (!Object.values(DISPLAY_MODES).includes(newMode)) {
      console.error(`Invalid display mode: ${newMode}`);
      return;
    }
    setDisplayMode(newMode);
    history.push(ROUTES[newMode]);
  }, [history]);

  useEffect(() => {
    const path = location.pathname;
    const entry = Object.entries(ROUTES).find(([_, route]) => path === route);
    const mode = entry ? entry[0] : null;
    if (mode) {
      setDisplayMode(mode);
    }
  }, [location.pathname]);

  return {
    displayMode,
    updateDisplayMode,
    isTableMode: displayMode === DISPLAY_MODES.TABLE,
    isFunnelMode: displayMode === DISPLAY_MODES.FUNNEL
  };
}; 